export * from './durchsuchen.component';
export * from './durchsuchen.component.module';